<template>
  <div>
    <div class="tw-pb-4">
      <div data-cy="page-title">
        <h2 class="page-title">Approver Report</h2>
      </div>
    </div>

    <div v-scroll-hint class="table-responsive reports-table">
      <table
        class="ld-table ld-table-header-blue"
        data-cy="table-approvers-report"
      >
        <thead>
          <tr>
            <th>Employee</th>
            <th>Employee Code</th>
            <th>Approver</th>
            <th>Approver Code</th>
            <th>Source</th>
          </tr>
        </thead>
        <tbody ref="body">
          <template v-if="approverReport.length">
            <ApproverReportTableRow
              v-for="reportRow in approverReport"
              :key="reportRow.id"
              :report-row="reportRow"
            />
          </template>
          <tr v-if="!loading && !approverReport.length">
            <td class="tw-bg-white" colspan="5">
              <NoData />
            </td>
          </tr>
        </tbody>
      </table>
      <Loading
        :blur="null"
        loader="dots"
        :is-full-page="false"
        :active.sync="loading"
        :container="$refs.body"
        class="tw-mt-12"
      />
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'

const NoData = () => import('@/components/NoData')
const ApproverReportTableRow = () =>
  import('@/components/reports/approver/ApproverReportTableRow')

export default {
  name: 'ApproverReportTable',

  components: {
    NoData,
    Loading,
    ApproverReportTableRow,
  },

  props: {
    approverReport: {
      type: Array,
      required: true,
    },

    loading: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
